<template>
    <section class="app-main">

        <div class="top-bar">
            <el-button  class="top-btn" type="primary" plain @click="handleShow()">添加</el-button>
            <el-button  class="top-btn" type="success" plain @click="handleBatch(1)">启用</el-button>
            <el-button  class="top-btn" type="info"    plain @click="handleBatch(2)">禁用</el-button>
            <el-button  class="top-btn" type="danger"  plain @click="handleBatch(3)" >删除</el-button>
        </div>

        <el-card shadow="hover">
            <el-table :data="tableData" @selection-change="handleChecked" empty-text="暂无管理员" height="600">
                <el-table-column type="selection"   width="80"          align="center"> </el-table-column>
                <el-table-column prop="nickname"    label="昵称"         width="120" align="center"></el-table-column>
                <el-table-column prop="phone"       label="手机号"       width="120" align="center"> </el-table-column>
                <el-table-column prop="role_title"  label="所属角色"       width="120" align="center"> </el-table-column>
                <el-table-column prop="created_at"  label="创建时间"     width="160" align="center"   ></el-table-column>
                <el-table-column prop="login_time"  label="登录时间"     width="160" align="center"></el-table-column>
                <el-table-column prop="status"     label="状态"         width="160" align="center" >
                    <template slot-scope="scope">
                        <el-switch v-model="scope.row.status" @change="handleStatus(scope.row)" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0"></el-switch>
                    </template>
                </el-table-column>
                <el-table-column label="编辑" align="center">
                    <template slot-scope="scope">
                        <el-button type="success" plain size="small"  @click="handleShow(scope.row)">修改</el-button>
                        <el-button type="danger"  plain size="small"  @click="handleDel(scope.row)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination background @current-change="reloadData" layout="prev, pager, next, jumper" style="padding:15px" :total="total" :page-size="size"></el-pagination>
         </el-card>

        <!-- 修改角色的弹框 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialog" :show-close="false" width="800px" center>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>昵称：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="nickname" placeholder="请输入昵称"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>手机号码：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="phone" placeholder="请输入手机号码"></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item" v-if="id == ''">
                <el-col :span="4" class="input-left">
                    <p>密码：</p>
                </el-col>
                <el-col :span="18">
                    <el-input v-model="password" placeholder="请输入密码" show-password></el-input>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>状态：</p>
                </el-col>
                <el-col :span="18">
                    <el-radio v-model="status" :label="1" border>启用</el-radio>
                    <el-radio v-model="status" :label="0" border>禁用</el-radio>
                </el-col>
            </el-row>
            <el-row class="line-item">
                <el-col :span="4" class="input-left">
                    <p>选择角色：</p>
                </el-col>
                <el-col :span="18">
                  <el-select v-model="gid"  placeholder="请选择角色" clearable style="width:100%">
                    <el-option v-for="item in options" :key="item.value" :label="item.title" :value="item.role_id" :disabled="item.status == 0"></el-option>
                  </el-select>
                </el-col>
            </el-row>
            <div slot="footer" class="dialog-footer">
                <el-button style="width:150px" @click="dialog = false">取 消</el-button>
                <el-button style="width:150px" type="primary" @click="handleBtn">确 定</el-button>
            </div>
        </el-dialog>


    </section>
</template>


<script>
import { manager, manager_add, manager_put, manager_del, get_roles } from '@/api/platform.js'

export default {
    data() {
        return {
            tableData: [],
            page:1,
            size:20,
            total:0,
            dialog:false,    // 控制显示 添加修改弹窗
            ids:[],          // table 选中数据的 id 数组集合
            dialogTitle:'添加管理员',
            id:'',           //  有id 是修改  没有id是添加
            nickname:'',
            phone:'',
            password:'',
            status:1,
            gid:[],       // 所选角色的  id 数组集合
            options:[],   // 角色列表
        }
    },
    methods: {
        // 获取栏目数据
        handleData(){
            let params = {
                page:this.page
            }
            manager(params).then(res => {
                if(res){
                    this.tableData = res.data.data
                    this.total     = res.data.total
                    this.size      = res.data.per_page
                }
            })
        },
        reloadData(page){
            this.page = page
            this.handleData()
        },
        // 获取角色
        handleRoles(){
            get_roles().then(res => {
                this.options = res.data
            })
        },
        // 显示添加修改弹窗
        handleShow(row){
            if(row){
                console.log(row)
                this.dialog      = true
                this.dialogTitle = '修改管理员'
                this.id          = row.id
                this.nickname    = row.nickname
                this.phone       = row.phone
                this.password    = ''
                this.status      = row.status
                this.gid         = row.gid
            }else{
                this.dialog      = true
                this.dialogTitle = '添加管理员'
                this.id          = ''
                this.nickname    = ''
                this.phone       = ''
                this.password    = ''
                this.status      = 1
                this.gid         = []
            }
        },
        // 弹窗里面 点击确定
        handleBtn(){
            this.dialog = false
            // 通过 this.id 为空来判断 添加 || 修改
            if(this.id == ""){
                this.handleAdd()
            }else{
                this.handlePut()
            }
            
        },
        // 添加栏目函数
        handleAdd(){
            let params = {
                nickname:this.nickname,
                phone:this.phone,
                password:this.password,
                status:this.status,
                gid:this.gid,
            }
            manager_add(params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
        // 修改栏目函数
        handlePut(){
            let params = {
                nickname:this.nickname,
                phone:this.phone,
                status:this.status,
                gid:this.gid,
            }
            manager_put(this.id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                    
                }
            })
        },
        // 修改状态
        handleStatus(row){
            let params = {
                status:row.status
            }
            manager_put(row.role_id,params).then(res => {
                if(res){
                    this.handleData()
                    this.$message({type:'success',message:res.msg,duration:1500})
                }
            })
        },
         // 点击删除 
        handleDel(it){
            this.$confirm(`此操作将删除 ${it.nickname} 管理员, 是否继续?`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'error'
            }).then(() => {
                manager_del(it.id).then(res => {
                    this.$message({type:'success',message:res.msg})
                    this.handleData();
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        // 监听 table 选中事件，获取选中数据的id 
        handleChecked(rows){
            rows.forEach(e => {
                this.ids.push(e.id)
            })
        },
        // 批量操作  1 启用 2 禁用 3 删除
        handleBatch(index){
            if(this.ids.length == 0){
                this.$message({type:'error',message:'请至少选中一条数据进行批量操作哦',})
                return false;
            }
            if(index == 1){
                let params = {
                    status:1
                }
                manager_put(this.ids,params).then(res => {
                    if(res){
                        this.handleData()
                        this.$message({type:'success',message:res.msg,duration:1500})
                    }
                })
            }else if(index == 2){
                let params = {
                    status:0
                }
                manager_put(this.ids,params).then(res => {
                    if(res){
                        this.handleData()
                        this.$message({type:'success',message:res.msg,duration:1500})
                    }
                })
            }else if(index == 3){
                this.$confirm(`此操作将删除所有选中的管理员, 是否继续?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                   manager_del(this.ids).then(res => {
                        this.$message({type:'success',message:res.msg})
                        this.handleData();
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                });
            }
        },
    },
    created(){
        this.handleData();
        this.handleRoles();
    },
    activated() {
        this.handleData()
    },
}
</script>

<style lang="less" scoped>
    section{
        .top-btn {
            width: 80px;
            margin-right: 15px;
        }
        .line-item {
            margin-bottom: 20px;
        }
        .input-left {
            height: 40px;
            line-height: 40px;
        }
    }
</style>